import { Company } from "../gateway/Company/Company";

const PAGE_LIMIT = 200;
const PARALLEL_PAGES = 4;

/**
 * Carteira inteira para a planilha de empresas, página a página, pela mesma rota da tela
 * (`get-segment-info`). Substitui o `get-by-accountingid`, que trazia tudo numa resposta só.
 */
export class GetAllCompaniesToExportUsecase {
    constructor() {
        this.CompanyGateway = new Company();
    }

    async execute({ accountingId = "", userId = null } = {}) {
        const payload = this.sanitizeInput({ accountingId, userId });
        if (!payload.accountingId) return [];

        const first = await this.getPage(payload, 0);
        const totalPages = Math.ceil(first.total / PAGE_LIMIT);
        const pages = [first.list];

        for (let page = 1; page < totalPages; page += PARALLEL_PAGES) {
            const batch = [];
            for (let p = page; p < Math.min(page + PARALLEL_PAGES, totalPages); p++) {
                batch.push(this.getPage(payload, p));
            }
            const results = await Promise.all(batch);
            results.forEach((result) => pages.push(result.list));
        }

        return this.uniqueById(pages.flat());
    }

    getPage({ accountingId, userId }, page) {
        return this.CompanyGateway.getSegmentInfoToExport({
            accountingId,
            userId,
            limit: PAGE_LIMIT,
            page,
            sort: [
                { field: "status", direction: 1 },
                { field: "name", direction: 1 }
            ]
        });
    }

    // A ordenação da Carteira não tem desempate por `_id`: filiais com mesmo status e nome podem
    // repetir na virada de página. Mantém a primeira ocorrência.
    uniqueById(companies) {
        const seen = new Set();
        return companies.filter((company) => {
            const id = company.props._id;
            if (seen.has(id)) return false;
            seen.add(id);
            return true;
        });
    }

    sanitizeInput({ accountingId = "", userId = null } = {}) {
        return {
            accountingId: String(accountingId || "").trim(),
            userId: userId || null
        };
    }
}
